import { useContext } from "react";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../../utils/FetchUtil";
import { useLocation, useNavigate } from 'react-router-dom';
import css from "../../css/common.module.css";
import HeaderNoAuth from "../Navigation/HeaderNoAuth";
import Footer from "../Navigation/Footer";
import UserContext from "../../contexts/UserContext";

function RootPage() {
	const { t, i18n } = useTranslation();
	FetchUtil.setBrowserLanguage(i18n);
	const location = useLocation();
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();

	if (userCtx.isAuthenticated) {
		navigate("/home_signin");
	}
	return (
		<div className="container-fluid">
			<HeaderNoAuth />
			<div className={"container-fluid viewh-85 " + css.bg}>

				<div className="row">
					<div className="col-md-4 col-sm-4 mt-8"></div>
					<div className="col-md-4 col-sm-4 mt-2">
						{location.state && location.state.errorMessage && (
							<div id="inerrorMessage" className={css.errorblock}>
								{location.state.errorMessage}
							</div>
						)}

					</div>
					<div className="col-md-4 col-sm-4 mt-8"></div>
				</div>
			</div>
		</div>
	);
}
export default RootPage;
